import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-md-12 d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none" }
const _hoisted_3 = { class: "fs-5" }
const _hoisted_4 = { class: "p-3" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "error-no-record" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Warning and Error Found")
], -1)
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "align-items-center my-2",
  style: {"color":"red"}
}, "Please download the error list to review the issues.", -1)
const _hoisted_10 = { class: "col-md-12 d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    modal: "",
    visible: _ctx.isVisible,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isVisible) = $event)),
    style: _normalizeStyle({width: (_ctx.title == 'Account' || _ctx.title == 'Company') ? '90vw' : '80vw'}),
    closable: false,
    draggable: false
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, [
            _createTextVNode("Import Preview "),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_Badge, {
                class: "mr-2",
                severity: "info",
                value: 'Total: ' + (_ctx.validCount + _ctx.errorCount + _ctx.warningCount)
              }, null, 8, ["value"]),
              _createVNode(_component_Badge, {
                class: "mr-2",
                severity: "success",
                value: 'Valid: ' + _ctx.validCount
              }, null, 8, ["value"]),
              _createVNode(_component_Badge, {
                class: "mr-2",
                severity: "warning",
                value: 'Warning: ' + _ctx.warningCount
              }, null, 8, ["value"]),
              _createVNode(_component_Badge, {
                class: "mr-2",
                severity: "danger",
                value: 'Error: ' + _ctx.errorCount
              }, null, 8, ["value"])
            ])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          (_ctx.isImportLoading)
            ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Download",
            icon: "pi pi-download",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadImportError())),
            disabled: _ctx.errorCount == 0 && _ctx.warningCount == 0
          }, null, 8, ["disabled"]),
          _createVNode(_component_Button, {
            class: "p-button-text p-button-sm",
            label: "Cancel",
            icon: "pi pi-times",
            onClick: _ctx.closeDialog
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            class: "p-button-sm",
            label: "Proceed",
            disabled: _ctx.validCount == 0 && _ctx.warningCount == 0 || _ctx.isImportLoading,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.proceedImport(true)))
          }, null, 8, ["disabled"])
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm",
          stripedRows: "",
          value: _ctx.invalidRows,
          paginator: true,
          rows: 5
        }, {
          empty: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_FontAwesomeIcon, {
                icon: ['fas', 'image'],
                size: "2x"
              }),
              _hoisted_7
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              style: _normalizeStyle({width: 8 - (_ctx.itemHeaders.length - 2) + '%'}),
              header: "Row #",
              field: "rowNum"
            }, null, 8, ["style"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemHeaders, (item, item_index) => {
              return (_openBlock(), _createBlock(_component_Column, {
                key: item_index,
                style: _normalizeStyle([{"word-wrap":"break-word"}, 'width: ' + item.width + ';']),
                header: item.value,
                field: 'items.' + item.value
              }, null, 8, ["style", "header", "field"]))
            }), 128)),
            _createVNode(_component_Column, {
              style: _normalizeStyle({width: 10 - (_ctx.itemHeaders.length - 2) + '%'}),
              header: "Type",
              field: "type"
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("span", {
                  class: _normalizeClass(["badge rounded-pill d-inline", [slotProps.data.type == 'Error' ? 'bg-danger' : 'bg-warning']])
                }, _toDisplayString(slotProps.data.type), 3)
              ]),
              _: 1
            }, 8, ["style"]),
            _createVNode(_component_Column, {
              style: _normalizeStyle({width: 30 - (_ctx.itemHeaders.length) + '%'}),
              header: "Remarks",
              field: "remarks"
            }, null, 8, ["style"])
          ]),
          _: 1
        }, 8, ["value"])
      ])
    ]),
    _: 1
  }, 8, ["visible", "style"]))
}